import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-rotate.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const RotateIcon = createSvgIcon(<Icon />, 'RotateIcon');
